import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui';
import { IconButton } from '@/components/ui/IconButton';

type MessageVersionSwitcherProps = {
  versionIds: string[];
  shownVersionId: string;
  disabled: boolean;
  onShowVersion: (versionId: string) => void;
};

export const MessageVersionSwitcher = ({
  versionIds,
  shownVersionId,
  disabled,
  onShowVersion,
}: MessageVersionSwitcherProps) => {
  const shownIndex = versionIds.indexOf(shownVersionId);
  if (versionIds.length < 2 || shownIndex === -1) return null;

  return (
    <XStack className="items-center gap-0.5 text-foreground-subtle">
      <IconButton
        icon={Icons.chevronLeft}
        size="xs"
        variant="ghost"
        aria-label="Previous version"
        tooltip="Previous version"
        disabled={disabled || shownIndex === 0}
        onClick={() => onShowVersion(versionIds[shownIndex - 1])}
      />
      <span className="text-sm tabular-nums">
        {shownIndex + 1} / {versionIds.length}
      </span>
      <IconButton
        icon={Icons.chevronRight}
        size="xs"
        variant="ghost"
        aria-label="Next version"
        tooltip="Next version"
        disabled={disabled || shownIndex === versionIds.length - 1}
        onClick={() => onShowVersion(versionIds[shownIndex + 1])}
      />
    </XStack>
  );
};
